import React, { useState } from 'react'
import { Tab } from 'react-tabs'
import { LvpMarginWrapper } from '../Layouts/LargeVideoPlayerLayout'
import PlusTabPanel from './PlusTabPanel'
import { PLUSTAB_HEADER, PLUSTAB_SUBHEADER } from './testIds'
import * as Styled from './styled'
import { Props } from './types'

const PlusTab: React.FunctionComponent<Props> = ({ copy }) => {
  const [selectedTab, setTab] = useState(copy.tabs[0].label)

  return (
    <Styled.Container>
      <LvpMarginWrapper>
        <Styled.Wrapper>
          <Styled.Header data-test={PLUSTAB_HEADER}>{copy.header}</Styled.Header>
          <Styled.SubHeader data-test={PLUSTAB_SUBHEADER}>
            {copy.subHeader}
          </Styled.SubHeader>
          <div>
            <Styled.Tabs onSelect={(tabIndex) => setTab(copy.tabs[tabIndex].label)}>
              <Styled.TabList>
                {copy.tabs.map((tab) => (
                  <Tab key={tab.label} data-test={tab.dataTestId}>
                    <Styled.StyledTabContents selected={selectedTab === tab.label}>
                      {tab.label}
                    </Styled.StyledTabContents>
                  </Tab>
                ))}
              </Styled.TabList>
              {copy.tabs.map((tab) => (
                <Styled.TabPanel
                  key={tab.label}
                  forceRender
                  aria-hidden={selectedTab !== tab.label}
                >
                  <PlusTabPanel tabInfo={tab} />
                </Styled.TabPanel>
              ))}
            </Styled.Tabs>
          </div>
        </Styled.Wrapper>
      </LvpMarginWrapper>
    </Styled.Container>
  )
}

export default PlusTab
